import { render, staticRenderFns } from "./PwdStep2Cmp.vue?vue&type=template&id=5fa231ae&"
import script from "./PwdStep2Cmp.vue?vue&type=script&lang=js&"
export * from "./PwdStep2Cmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports